import { render, staticRenderFns } from "./LtPagination.vue?vue&type=template&id=03948e76&scoped=true"
import script from "./LtPagination.vue?vue&type=script&lang=js"
export * from "./LtPagination.vue?vue&type=script&lang=js"
import style0 from "./LtPagination.vue?vue&type=style&index=0&id=03948e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03948e76",
  null
  
)

export default component.exports